import { Text } from "@chakra-ui/react"

const NavCategoryHeader = ({ title }: { title: string }) => {
    return (
        <Text className='flex pl-3 text-xs font-bold text-gray-400 uppercase place-self-start w-fit'>
            {title}
        </Text>
    )
}

export default NavCategoryHeader
